const Data = [
    {
        id: 1,
         img: "Victor.png",
        teamName: "Nkire Victor",
        path: "Front-End Developer"
       
        
    },
    {
        id: 2,
        img: "Emma.png",
        teamName: "Uche Emmanuel",
        path: "Front-End Developer"
        
    },
    {
        id: 3,
         img: "Abayomi.png",
        teamName: "Abayomi Akinruli",
        path: "Product Designer (UI/UX)"

      
        
    },
    {
        id: 4,
        img: "Rita.png",
        teamName: "Okolo Rita",
        path: "Product Designer (UI/UX)"
        
    },
    {
        id: 5,
        img: "Lewis.png",
        teamName: "Lewis Irabor",
        path: "Product Designer (UI/UX)"
        
    },
    {
        id: 6,
          img: "Salami.png",
        teamName: "Salami Tokumboh",
        path: "Product Designer (UI/UX)"
       
        
    },
    {
        id: 7,
         img: "null.png",
        teamName: "Sochima Henry",
        path: "Back-End Developer"
        
        
        
    },
    {
        id: 8,

        img: "Precious.png",
        teamName: "Omeje Victor",
        path: " Web3 Enthusiast"
       
    },
    {
        id: 9,
         img: "Ifeanyi.png",
        teamName: "Asogwa Ifeanyi",
        path: "Graphic Designer "
       
        
    },
    // {
    //     id: 10,
    //     img: "null.png",
    //     teamName: "Sochima Henry",
    //     path: "Back-End Developer"
        
    // },
    // {
    //     id: 11,
    //     img: "null.png",
    //     teamName: "Sochima Henry",
    //     path: "Back-End Developer"
        
    // },
    // {
    //     id: 12,
    //     img: "null.png",
    //     teamName: "Joy Peter",
    //     path: "Content Writer"
        
    // },
     
    
];
export default Data;